import React, {FunctionComponent, useContext} from 'react';
import {ActiveLinkPage} from "../ActiveLinkPage/ActiveLinkPage";
import {PageContext} from "../../context/PageContext";
import {AcceptedSignaturePage} from "../AcceptedSignaturePage/AcceptedSignaturePage";
import {RejectedSignaturePage} from "../RejectedSignaturePage/RejectedSignaturePage";
import {PaidPage} from "../PaidPage/PaidPage";
import {InvoiceProvider} from "../../context/InvoiceContext";
import {CompanyProvider} from "../../context/CompanyContext";
import {VoidPage} from "../VoidPage/VoidPage";
import {OverduePage} from "../OverduePage/OverduePage";
import {OptionProvider} from "../../context/OptionContext";
import {ItemsProvider} from "../../context/ItemsContext";
import {AddOnItemsProvider} from "../../context/AddOnItemsContext";
import {WisetackProvider} from "../../context/WisetackContext";
import {BankOfAmericaProvider} from "../../context/BankOfAmericaContext";
import {RainforestProvider} from "../../context/RainforestContext";
import {FullstackProvider} from "../../context/FullstackContext";
import {NmiProvider} from "../../context/NmiContext";
import {CardFeeRecoveryProvider} from "../../context/CardFeeRecoveryContext";
import {ServerDataContext} from "../../context/ServerDataContext";
import {InvoiceProviders} from "../InvoiceProviders/InvoiceProviders";
import {VariantProposalPage} from "../VariantProposalPage/VariantProposalPage";

export const MainPage: FunctionComponent = () => {
    const pageContext = useContext(PageContext);
    const isVariantProposalMode = Boolean(useContext(ServerDataContext).invoice?.is_variant_proposal_mode);

    const getPage = () => {
        if (pageContext.isVoidPage()) {
            return <InvoiceProvider><CompanyProvider><VoidPage/></CompanyProvider></InvoiceProvider>
        }
        if (pageContext.isOverduePage()) {
            return <InvoiceProvider><CompanyProvider><OverduePage/></CompanyProvider></InvoiceProvider>
        }
        if (pageContext.isRejectedSignaturePage()) {
            return <InvoiceProvider><RejectedSignaturePage/></InvoiceProvider>
        }
        if (pageContext.isPaidPage()) {
            return <InvoiceProvider><PaidPage/></InvoiceProvider>
        }
        if (isVariantProposalMode && (pageContext.isActivePage() || pageContext.isAcceptedSignaturePage())) {
            return <InvoiceProviders><VariantProposalPage/></InvoiceProviders>
        }
        if (pageContext.isAcceptedSignaturePage()) {
            return <InvoiceProvider><CompanyProvider><CardFeeRecoveryProvider><BankOfAmericaProvider><RainforestProvider><FullstackProvider><NmiProvider><ItemsProvider><AddOnItemsProvider><WisetackProvider><OptionProvider><AcceptedSignaturePage/></OptionProvider></WisetackProvider></AddOnItemsProvider></ItemsProvider></NmiProvider></FullstackProvider></RainforestProvider></BankOfAmericaProvider></CardFeeRecoveryProvider></CompanyProvider></InvoiceProvider>
        }
        return <ActiveLinkPage/>
    }

    return (
        getPage()
    );
};
